// routes.js
import LoginPage from "../features/authentication/pages/login-page/login-page";
import ChatPage from "../features/chat/pages/chat-page/chat-page";
import SettingsPage from "../features/settings/pages/settings-page/settings-page";
import ManageContactsPage from "../features/manage-contacts/pages/manage-contacts-page/manage-contacts-page";
import ManageUsersPage from "../features/manage-users/pages/manage-users-page/manage-users";
import ResetPasswordPage from "../features/authentication/pages/reset-password/reset-password";
import ConnectContactsPage from "../features/manage-contacts/pages/manage-contacts-page/connect-contacts-page";
import ManageGroupsPage from "../features/manage-contacts/pages/manage-groups-page/manage-groups-page";
import TranscriptPage from "../features/chat/pages/transcript-page/transcript-page";
import DeveloperAccessPage from "../features/developer-access/pages/developer-access-page/developer-access-page";
import GroupExternalApiPage from "../features/group-external-api/pages/group-external-api-page/group-external-api-page";
import ExternalTemplatesPage from "../features/external-templates/pages/external-templates-page/external-templates-page";
import PublicApiDocsPage from "../features/public-api-docs/pages/public-api-docs-page/public-api-docs-page";
import QrGeneratorPage from "../features/qr-generator/pages/qr-generator-page/qr-generator-page";
import B2CLoginPage from "../features/authentication/pages/b2c-login-page/b2c-login-page";
import EmbedConnectContactsPage from "../features/embed/pages/embed-connect-contacts/embed-connect-contacts";
import EmbedFloatingChatOptionPage from "../features/embed/pages/embed-floating-chat-option/embed-floating-chat-option";
import WhatsAppGroupsPage from "../features/whatsapp-groups/pages/whatsapp-groups-page/whatsapp-groups-page";
import SignupPage from "../features/authentication/pages/signup-page/signup-page";
import CompleteSignupPage from "../features/authentication/pages/complete-signup-page/complete-signup-page";
import IntegrationsPage from "../features/integrations/pages/integrations-page/integrations-page";

const routes = [
  // Public Routes
  {
    path: "/login",
    component: LoginPage,
    isProtected: false,
  },
  {
    path: "/login-b2c",
    component: B2CLoginPage,
    isProtected: false,
  },
  {
    path: "/embed/connect",
    component: EmbedConnectContactsPage,
    isProtected: false,
  },
  {
    path: "/embed/floating-chat",
    component: EmbedFloatingChatOptionPage,
    isProtected: false,
  },
  {
    path: "/reset-password",
    component: ResetPasswordPage,
    isProtected: false,
  },
  {
    path: "/signup",
    component: SignupPage,
    isProtected: false,
  },
  {
    path: "/signup/complete",
    component: CompleteSignupPage,
    isProtected: false,
  },
  {
    path: "/api-docs",
    component: PublicApiDocsPage,
    isProtected: false,
  },
  {
    path: "/qr-generator",
    component: QrGeneratorPage,
    isProtected: false,
  },
  // {
  //   path: "/forgot-password",
  //   component: ForgotPassword,
  //   isProtected: false,
  // },

  // Protected Routes (All will be inside DashboardLayout)
  {
    path: "/",
    component: ManageGroupsPage,
    isProtected: true,
  },
  {
    path: "/manage-users",
    component: ManageUsersPage,
    isProtected: true,
  },
  {
    path: "/manage-contacts",
    component: ManageContactsPage,
    isProtected: true,
  },
  {
    path: "/connect-contacts",
    component: ConnectContactsPage,
    isProtected: true,
  },
  {
    path: "/manage-groups",
    component: ManageGroupsPage,
    isProtected: true,
  },
  {
    path: "/whatsapp-chats",
    component: ChatPage,
    isProtected: true,
  },
  {
    path: "/transcript-chats",
    component: TranscriptPage,
    isProtected: true,
  },
  {
    path: "/settings",
    component: SettingsPage,
    isProtected: true,
  },
  {
    path: "/developer-access",
    component: DeveloperAccessPage,
    isProtected: true,
  },
  {
    path: "/group-external-api",
    component: GroupExternalApiPage,
    isProtected: true,
  },
  {
    path: "/external-templates",
    component: ExternalTemplatesPage,
    isProtected: true,
  },
  {
    path: "/whatsapp-groups",
    component: WhatsAppGroupsPage,
    isProtected: true,
  },
  {
    path: "/integrations",
    component: IntegrationsPage,
    isProtected: true,
  },

  // Fallback Route (404)
  {
    path: "*",
    component: LoginPage,
    isProtected: false,
  },
];

export default routes;
